import { render } from "./ContactFooter.vue?vue&type=template&id=3db613f8&scoped=true"
import script from "./ContactFooter.vue?vue&type=script&lang=js"
export * from "./ContactFooter.vue?vue&type=script&lang=js"

import "./ContactFooter.vue?vue&type=style&index=0&id=3db613f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db613f8"]])

export default __exports__